import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// 2026-11-03 (GT-1): build.obto.co uses the same consent loader as www.obto.co instead of its own copy.
// Tag ids come from the staging tenant's property co.obto.gtm.tags. The loader shows the banner, honours
// Do Not Track and GPC, and loads Google, Meta and LinkedIn tags only after "Allow measurement".
const LOADER_SRC = "https://www.obto.co/api/www/consent.js?t=staging";

const loadConsentScript = () => {
  if (typeof document === "undefined" || document.getElementById("obto-consent-loader")) return;
  const script = document.createElement("script");
  script.id = "obto-consent-loader";
  script.async = true;
  script.src = LOADER_SRC;
  document.head.appendChild(script);
};

// Same signature as before; a no-op until the loader is in and the visitor has allowed measurement.
export const trackMarketingEvent = (eventName, properties = {}) =>
  typeof window !== "undefined" && typeof window.obtoTrackMarketingEvent === "function"
    ? window.obtoTrackMarketingEvent(eventName, properties)
    : false;

export default function MarketingObservability() {
  const location = useLocation();
  const firstRoute = useRef(true);

  useEffect(() => {
    loadConsentScript();
  }, []);

  useEffect(() => {
    // The loader sends the first page view itself; later route changes are sent from here.
    if (firstRoute.current) {
      firstRoute.current = false;
      return undefined;
    }
    const timer = window.setTimeout(() => {
      if (typeof window.obtoMarketingPageView === "function") window.obtoMarketingPageView();
    }, 0);
    return () => window.clearTimeout(timer);
  }, [location.pathname, location.search, location.hash]);

  return null;
}
